module.exports = __webpack_public_path__ + "static/media/partner_meituan.506d45f1.png";